// library imports
import { useState, useEffect } from "react";
// hook imports
import useFetch from "../hooks/useFetch";

export default function useSiteSelection() {
  const [fetchWrapper] = useFetch();

  const [getSiteSelectionLoading, setGetSiteSelectionLoading] = useState(false);

  const [siteList, setSiteList] = useState([]);
  const [siteSelected, setSiteSelected] = useState(null);

  /* API to get site selection */
  function getSiteSelection() {
    setGetSiteSelectionLoading(true);
    fetchWrapper({
      endpoint_url: "layout/getSiteSelection",
      onSuccess: (fetch_output) => {
        setGetSiteSelectionLoading(false);
        if (fetch_output.status === true) {
          setSiteList(fetch_output.site_list);
          if (fetch_output.site_list.length > 0) {
            setSiteSelected(fetch_output.site_list[0].value);
          }
        }
      },
    });
  }

  useEffect(() => {
    getSiteSelection();
  }, []);

  return [siteSelected, setSiteSelected, siteList, getSiteSelectionLoading];
}
